import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { usePageMeta } from "@/hooks/usePageMeta";

const quickLinks = [
  { label: "电影专区", to: "/category/movie", icon: "ri-film-line" },
  { label: "电视剧专区", to: "/category/tv", icon: "ri-tv-2-line" },
  { label: "综艺专区", to: "/category/variety", icon: "ri-mic-line" },
];

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 | 蜜桃33",
    description: "你访问的页面不存在或已被移动，返回蜜桃33首页继续浏览影视资源。",
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />

      <main className="flex w-full flex-1 items-center justify-center px-4 py-20">
        <div className="w-full max-w-xl text-center">
          <p className="font-heading text-7xl font-bold text-primary-200 md:text-8xl">404</p>
          <h1 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这个页面走丢了
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-foreground-500">
            没有找到你访问的地址，它可能已经被移动或从未存在。可以从下面回到首页，或者直接进入想看的分类。
          </p>
          <p className="mt-2 break-all rounded-md bg-background-100 px-3 py-2 text-[11px] text-foreground-400">
            当前路径：{location.pathname}
          </p>

          <div className="mt-6 flex flex-col justify-center gap-2 sm:flex-row">
            <Link
              to="/"
              className="inline-flex h-11 cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              返回首页
            </Link>
            <Link
              to="/search"
              className="inline-flex h-11 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-6 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-search-line" />
              去搜索影视
            </Link>
          </div>

          <div className="mt-10 grid gap-3 sm:grid-cols-3">
            {quickLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-3 py-4 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className={`${link.icon} text-lg`} />
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}